export function getStatusIcon(status: string | null | undefined): string {
	if (!status) return "";

	switch (status.toLowerCase()) {
		case "unread":
		case "sent":
		case "delivered":
		case "scheduled":
		case "readyforreview":
			return "icon-calendar-check-stroke";
		case "inprogress":
		case "processing":
			return "icon-refresh-clockwise";
		case "completed":
		case "reviewed":
			return "icon-check-big";
		case "notstarted":
			return "mdi-timer-sand";
		default:
			return "";
	}
}
